
import { IssueType } from '@/proto/issue';
import { IFilterRule, IGetConfigRsp, ILabel } from '@/service/filter-rule';

// 黑产数据
export const BLACK_MARKET = 'black_market';


interface IOptions{
  value: string;
  label: string;
}
export interface IConfigObject{
  values?: IOptions[];
  labelOptions?: IOptions[];
}
export interface IFilterConfig{
  config: IGetConfigRsp;
  filterRules: IFilterRule[];
  configObject: Record<string, IConfigObject>;
}

export const getObjectLabel = (
  platform: string, labelOptions?: ILabel[]|null,
  rulesData?: IFilterRule[],
) => labelOptions?.filter(item => (rulesData ? !rulesData
  ?.some(rulesDataItem => rulesDataItem.monitorKey === platform
      && rulesDataItem.labelKey === item.labelKey) : true))
  ?.map(item => ({ label: item.labelName || '', value: item.labelKey || '' })) || [];

export const getIssueFilterConfig = (issueType: IssueType, filterConfig: any): IConfigObject => {
  switch (issueType) {
    case IssueType.ISSUE_TYPE_CRASH:
      return filterConfig?.configObject?.crash;
    case IssueType.ISSUE_TYPE_ELECTRON_CRASH:
      return filterConfig?.configObject?.crash;
    case IssueType.ISSUE_TYPE_ANR_BUGLY:
    case IssueType.ISSUE_TYPE_ANR:
      return filterConfig?.configObject?.anr;
    case IssueType.ISSUE_TYPE_ERROR:
    case IssueType.ISSUE_TYPE_ELECTRON_JS_PROMISE_ERROR:
      return filterConfig?.configObject?.error;
    case IssueType.ISSUE_TYPE_FOOM_BUGLY:
      return filterConfig?.configObject?.oom;
    case IssueType.ISSUE_TYPE_FOOM:
      return filterConfig?.configObject?.foom;
    default:
      return {};
  }
};
